<template>
  <span
    v-if="value"
  >
    <v-tooltip
      open-delay="100"
      top
    >
      <template
        v-slot:activator="{ on, attrs }"
      >
        <span
          v-bind="attrs"
          v-on="on"
        >
          {{ text }}
        </span>
      </template>
      <span>
        {{ dateTime.toFormat('ff') }}
      </span>
    </v-tooltip>
  </span>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'DateTime',

  props: {
    format: {
      default: 'D',
      type: String,
    },
    relative: {
      default: false,
      type: Boolean,
    },
    value: {
      default: null,
      type: String,
    },
  },

  computed: {
    dateTime () {
      return DateTime.fromISO(this.value)
    },

    text () {
      return this.relative === true
        ? this.dateTime.toRelative()
        : this.dateTime.toFormat(this.format)
    },
  },
}
</script>
